import { render, staticRenderFns } from "./LedgerPrintReport.vue?vue&type=template&id=12b8fbbf&scoped=true&"
import script from "./LedgerPrintReport.vue?vue&type=script&lang=js&"
export * from "./LedgerPrintReport.vue?vue&type=script&lang=js&"
import style0 from "./LedgerPrintReport.vue?vue&type=style&index=0&id=12b8fbbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8fbbf",
  null
  
)

export default component.exports